import {useViewNavigate} from '@common'
import {NavigationPathKey, TranslationKey} from '@enums'
import {Box, Typography} from '@mui/material'

import {useTranslation} from 'react-i18next'

import logo from '@images/amplio-logo.png'

import {ContentContainer, BackButton, imageStyle} from './style'

/**
 * Logout page with a message and a Login button
 */
export function LogoutPage() {
  const navigate = useViewNavigate()
  const {t} = useTranslation()
  return (
    <ContentContainer>
      <Box component="img" src={logo} style={imageStyle} onClick={() => navigate(NavigationPathKey.DASHBOARD)} />
      <Typography variant="h2">{t(TranslationKey['You have successfully logged out.'])}</Typography>
      <BackButton variant="contained" onClick={() => navigate(NavigationPathKey.LOGIN)}>
        {t(TranslationKey.Login)}
      </BackButton>
    </ContentContainer>
  )
}
